import type React from "react";
import {useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {usePlaylist} from "~/api/hooks/usePlaylist";
import CustomButton from "~/component/common/CustomButton";

import type {PlayLevelParams} from "../PlayLevelParams";

const PreviousButton: React.FC = () => {
  const {id, playlistId} = useParams<PlayLevelParams>();
  const {data: playlistData} = usePlaylist({id: playlistId});
  const navigate = useNavigate();

  const handlePrevious = useCallback(() => {
    if (playlistData && id) {
      const index = playlistData.levelIds.indexOf(id);
      if (index > 0) {
        const previousLevelId = playlistData.levelIds[index - 1];
        navigate(`/playlist/${playlistId}/play/${previousLevelId}`);
      }
    }
  }, [id, navigate, playlistData, playlistId]);

  return (
    <CustomButton
      onClick={handlePrevious}
      aria-label="Previous"
      className="w-10 h-10 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-600 text-white disabled:text-gray-300 rounded-lg transition-colors flex items-center justify-center"
      disabled={playlistData?.levelIds.indexOf(id!) === 0}
    >
      <FontAwesomeIcon icon={faArrowLeft} size="xl" />
    </CustomButton>
  );
};

export default PreviousButton;
